module.exports = __webpack_public_path__ + "img/blue_check_icon.09669268.svg";